import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

class Menu extends Component {
	render() {
		return (
			<nav className="navbar navbar-expand-sm navbar-dark bg-dark" style={{ marginBottom: "1em" }}>
				<a className="navbar-brand">
					<img src={require('../../img/carteira.svg')} width="30" height="30" alt="logo" />
				</a>
				<button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent">
					<span className="navbar-toggler-icon" />
				</button>
				<div className="collapse navbar-collapse" id="navbarSupportedContent">
					{this.props.nomeUsuario && (
						<ul className="navbar-nav">
							<li className="nav-item">
								<NavLink to="/" className="nav-link" activeClassName="active" data-test="menu-home" alt="Home" exact >
									<i className="fas fa-home" style={{ cursor: "pointer" }} title="Home"  />
								</NavLink>
							</li>
							<li className="nav-item">
								<NavLink to="/movimentacao" className="nav-link" activeClassName="active" data-test="menu-movimentacao" alt="Cadastrar movimentação" >
									<i className="fas fa-hand-holding-usd" style={{ cursor: "pointer" }} title="Cadastrar movimentação" />
								</NavLink>
							</li>
							<li className="nav-item">
								<NavLink to="/extrato" className="nav-link" activeClassName="active" data-test="menu-extrato" alt="extrato" >
									<i className="fas fa-history" style={{ cursor: "pointer" }} title="extrato" />
								</NavLink>
							</li>
							<li className="nav-item dropdown navbar-dark bg-dark">
								<a href="#" className="nav-link dropdown-toggle" data-toggle="dropdown" data-test="menu-settings" alt="settings" >
									<i className="fas fa-cog" style={{ cursor: "pointer" }} title="settings" />
								</a>
								<div className="dropdown-menu bg-dark">
									<NavLink to="/contas" className="nav-link dropdown-item">
										Contas
								</NavLink>
									<NavLink to="/reset" className="nav-link dropdown-item">
										Resetar
								</NavLink>
									<NavLink to="/logout" className="nav-link dropdown-item">
										Sair
								</NavLink>
								</div>
							</li>
						</ul>)}
					{!this.props.nomeUsuario && (
						<ul className="navbar-nav">
							<li className="nav-item">
								<NavLink to="/login" className="nav-link" activeClassName="active" >
									Login
								</NavLink>
							</li>
							<li className="nav-item">
								<NavLink to="/registro" className="nav-link" activeClassName="active" >
									Registrar
								</NavLink>
							</li>
						</ul>
					)}
				</div>
			</nav>
		);
	}
}

Menu.propTypes = {
	nomeUsuario: PropTypes.string.isRequired
};

function mapStateToProps({ nomeUsuario, router }) {
	return {
		nomeUsuario,
		router
	};
}

export default connect(mapStateToProps)(Menu);



// WEBPACK FOOTER //
// ./src/components/common/Menu.js